let store = null;
/** Called once at app bootstrap to wire the environment's storage handler. */
export function registerPortalSettingsStore(handler) {
    store = handler;
}
export function getPortalSettingsStore() {
    if (!store) {
        throw new Error('portal-settings: no store registered — call registerPortalSettingsStore() at bootstrap');
    }
    return store;
}
//# sourceMappingURL=store.js.map